<template>
  <div class="box">
    <el-form :model="info" label-position="right" :rules="rules" ref="ruleForm" label-width="80px" size="small">
      <el-form-item label="钉钉" prop="dingding_url">
        <el-input v-model="info.dingding_url" placeholder="请输入Webhook地址" clearable></el-input>
      </el-form-item>
      <el-form-item label="飞书" prop="feishu_url">
        <el-input v-model="info.feishu_url" placeholder="请输入飞书Webhook" clearable></el-input>
      </el-form-item>
      <el-form-item label="企微" prop="qw_url">
        <el-input v-model="info.qw_url" placeholder="请输入企微Webhook" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submitForm('ruleForm')">保存</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>

export default {
  data() {
    return {
      info: {
        dingding_url: '',
        feishu_url: '',
        qw_url: ''
      },
      rules: {
      }
    };
  },
  created() {
    this.getInfo()
  },
  mounted() {
  },
  computed: {
  },
  props: {
  },
  watch: {
  },
  methods: {
    getInfo() {
      this.$api.merchant.sysConfigDetail(res=>{
        if(res.errcode == 0) {
          this.info = res.data
        }
      })
    },
    submitForm(formName) {
      var _this = this
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          var param = _this.info
          this.$api.merchant.sysConfigEdit(param,function (res) {
            if(res.errcode == 0) {
              _this.success(res.errmsg)
              _this.$emit('call')
            } else {
              _this.fail(res.errmsg)
            }
          })
        } else {
          return false;
        }
      });
    },
  }
};
</script>
<style scoped>
</style>
